import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import StudentSidebar from './StudentSidebar';
import StudentTopBar from './StudentTopBar';
import MobileTabBar from './MobileTabBar';
import AuthService from '../services/authService';
import { useLocation, useNavigate } from 'react-router-dom';
import theme from '../styles/theme';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: ${theme.gradientSoft};
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));

  @media (max-width: 768px) {
    padding: 16px;
    /* Clears the fixed MobileTabBar (~64px) plus the home-indicator safe area. */
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }

  ${(p) => p.$fullBleed && `
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
    padding-bottom: env(safe-area-inset-bottom);

    @media (max-width: 768px) {
      padding: 0;
      padding-bottom: calc(60px + env(safe-area-inset-bottom));
    }
  `}
`;

const isMobileViewport = () =>
  typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;

export default function StudentLayout({ children, title, requireSelection = true, fullBleed = false }) {
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobileViewport());
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!requireSelection) return;

    const data = AuthService.getUser();
    const hasSelection = !!data?.selectedRegistration;
    if (!hasSelection && location.pathname !== '/app/select-course') {
      navigate('/app/select-course', { replace: true });
    }
  }, [requireSelection, navigate, location.pathname]);

  return (
    <Root>
      <StudentSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <Main $sidebarOpen={sidebarOpen}>
        <StudentTopBar title={title} onMenuClick={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen} />
        <Content $fullBleed={fullBleed}>{children}</Content>
      </Main>
      <MobileTabBar onMore={() => setSidebarOpen(true)} />
    </Root>
  );
}
